import Affiliate from './Affiliate';
import NodeCookie from './NodeCookie';

export default class Rakuten extends Affiliate {
    constructor() {
        super();
        this.affiliateName = 'rakuten';
        this.cookieDomain = new NodeCookie();
        this.cookieNames = ['rmStoreGateway', 'source'];
    }

    prepareCookie() {
        const { utm_source,  ranMID, ranSiteID } = this.urlParams;
        this.cookieDomain.sendCookie({ name: 'rmStoreGateway', value: generateRakutenCookie(ranMID, ranSiteID), expiryInDays: 30 });
        this.cookieDomain.sendCookie({ name: 'source', value: utm_source, expiryInDays: 30 });
    }
}

const generateRakutenCookie = (amid, atrv) => {
    const currentDatetime = new Date();
    const ald = `${currentDatetime.getUTCFullYear()}${twoDigitFormat(currentDatetime.getMonth() + 1)}${twoDigitFormat(currentDatetime.getUTCDate())}_${twoDigitFormat(currentDatetime.getUTCHours())}${twoDigitFormat(currentDatetime.getUTCMinutes())}`;
    const auld = Math.round(currentDatetime.getTime() / 1000);
   
    const cookieValue = `amid:${amid}|ald:${ald}|auld:${auld}|atrv:${atrv}`;
    return decodeURIComponent(cookieValue);
}

const twoDigitFormat = (number) => ("0" + number).slice(-2);


// WEBPACK FOOTER //
// ./src/Common/Helpers/TrackingAffiliate/Rakuten.js